<template>
  <div
    class="pinWindow"
    :class="{
      fix: !selectionText,
    }"
  >
    <AppWindowHeader @pin="pin" @close="onClose" :pinned="pinned" />
    <memo
      :memo="memo"
      :menu_thread_hidden="true"
      :backlink_hidden="true"
      :http_direct="http_direct"
      v-on:tag-clicked="tagClicked"
      v-on:memo-updated="updatedMemo"
      v-on:share-clicked="shareClicked"
      :isInPinWindow="true"
      v-on:memo-editing="memoEditing"
      ref="memo"
    ></memo>
  </div>
</template>
<script>
import Memo from '../components/Memo.vue'
import DBUtil from '../utils/DBUtil'
import api from '../../api'
import AppWindowHeader from '../components/Desktop/AppWindowHeader.vue'
export default {
  name: 'PinWindow',
  components: {
    Memo,
    AppWindowHeader,
  },
  data() {
    return {
      memo: null,
      http_direct: false,
      pinned: false,
      selectionText: '',
    }
  },
  methods: {
    memoEditing(editing) {
      //this.$nextTick(() => {
      //  console.log(this.$refs.memo)
      //  const headerHeight = 41
      //  const editorBarHeight = 40
      //  const fileHeight = document.querySelector('.files').offsetHeight
      //  // 修改 .editor-content .ProseMirror height
      //  //const proseMirror = document.querySelector('.editor-content div')
      //  //proseMirror.style.height = 'calc(100vh' - 81 + fileHeight + 'px)'
      //  //proseMirror.style.maxHeight = 'calc(100vh' - 81 + fileHeight + 'px)'
      //})
    },
    onClose() {
      window.ipcRenderer.send('close-window', { id: window.remote.getCurrentWindow().id })
    },
    pin() {
      this.pinned = !this.pinned
      window.ipcRenderer.send('set-window-on-top', { pinned: this.pinned, id: window.remote.getCurrentWindow().id })
    },
    updatedMemo(memo) {
      this.memo.content = memo.content
    },
    tagClicked(tag) {
      if (this.isEditing) return
      console.log('tagClicked', tag)
    },
    shareClicked(memo) {
      console.log('shareClicked', memo)
    },
    loadMemo(slug) {
      this.memo = {}
      this.loading = true
      let vm = this
      DBUtil.getMemo(slug, true).then(function (memo) {
        if (memo == undefined) {
          vm.getMemoDetailByHttp(slug)
        } else {
          vm.memo = memo
          vm.loading = false
          vm.http_direct = false
          const { content } = memo
          const contentHtml = content.replace(/<[^>]+>/g, '')
          const contentText = contentHtml.length > 20 ? contentHtml.substring(0, 20) + '...' : contentHtml
          // 修改标题
          document.title = 'flomo - ' + contentText
        }
      })
    },
    getMemoDetailByHttp(memo_id) {
      api.call('GET', '/memo/' + memo_id, {}, (response) => {
        this.loading = false
        if (response.data && response.data.code === -1) {
          this.closeClicked()
        } else if (response.data && response.data.code === 0) {
          this.memo = response.data.data
        }
      })
    },
    getWindowState() {
      const currentWindowId = window.remote.getCurrentWindow().id
      window.ipcRenderer.send('request-window-state', currentWindowId)

      // 监听窗口状态响应
      window.ipcRenderer.on('window-state', (event, { id, windowState }) => {
        // 在这里处理接收到的窗口状态
        console.log(`Received window state for window ${id}:`, windowState)
        const { isAlwaysOnTop } = windowState
        this.pinned = isAlwaysOnTop
      })

      //// 窗口显示时，重新获取 Memo
      //window.ipcRenderer.on('window-show', (event, { id }) => {
      //  if (id === currentWindowId) {
      //    console.log(`Received window show for window ${id}`)
      //    const { slug } = this.$route.params
      //    this.loadMemo(slug)
      //  }
      //})

      //window.ipcRenderer.on('window-focus', (event, { id }) => {
      //  if (id === currentWindowId) {
      //    console.log(`Received window focus for window ${id}`)
      //    const { slug } = this.$route.params
      //    this.loadMemo(slug)
      //  }
      //})
      // 数据同步后，重新获取 Memo
      window.ipcRenderer.on('sync-window', (event, { id }) => {
        if (id === currentWindowId) {
          console.log(`Received sync window for window ${id}`)
          const { slug } = this.$route.params
          this.loadMemo(slug)
        }
      })
    },
  },

  created() {
    const { slug } = this.$route.params
    this.loadMemo(slug)
    this.getWindowState()
    document.addEventListener('selectionchange', () => {
      const selection = window.getSelection()
      const selectionText = selection.toString()
      this.selectionText = selectionText
    })
  },
}
</script>
<style lang="scss">
.pinWindow {
  width: 100vw;
  height: 100vh;
  background: var(--defaultBg);
  div {
    .display {
      &:hover {
        box-shadow: none;
      }
    }
  }
  .blurd,
  .focused {
    border: none !important;
    box-shadow: unset;
  }

  .editor-content .ProseMirror {
    max-height: calc(100vh - 81px);
    padding-bottom: 200px;
  }
  .hasFiles .files {
    position: fixed;
    bottom: 40px;
    background: var(--defaultBg);
    z-index: 1;
    width: 100%;
  }
  .editor-menu-bar {
    position: fixed;
    bottom: 0px;
    background: var(--defaultBg);
    z-index: 1;
    width: 100%;
  }
}

.fix {
  .header {
    -webkit-app-region: drag;
  }
}
</style>
